export function isImageAssetVideo(image) {
  return image && image.indexOf('.mp4') !== -1;
}
